module.exports = __webpack_public_path__ + "static/img/detailTitle5.06a72bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/detailTitle5.png
// module id = 11
// module chunks = 0